import { useTranslations, useLocale } from 'next-intl'
import ZooIcon from '../../../icons/zooIcon'

export interface LoyaltyPointsBadgeProps {
  points: number
}

const LoyaltyPointsBadge = ({ points }: LoyaltyPointsBadgeProps) => {
  const t = useTranslations()
  const locale = useLocale()

  return(
    <div
      className='mb-4 flex w-fit items-center justify-start rounded-b bg-state-bonus-sand p-8 text-xs font-bold text-state-bonus-blue'
    >
      <ZooIcon name='white-heart' size={16} className='mx-6 shrink grow-0'/>
      <p className='shrink-0 grow'>
        {t('account.loyalty.points', {
          points: (points).toLocaleString(locale),
        })}
      </p>
    </div>
  )
}

export default LoyaltyPointsBadge
